export default {
	state: {
		room: {
			name: "",
			maxrad: 0,
			roomtotal: 0,
			roomtotaldementia: "0",
			occupancy: "Single",
			ensuite: "Private ensuite",
			sizefrom: 0,
			sizeto: 0,
			sizeoption: "Size-is-static",
			photo: "",
			features: "",
			commonareas: "",
			includedservices: "",
			extraservices: false,
			extraservicesdescription: "",
			extraservicesfee: 0,
			extraservicesmandatory: true,
			srsfeefrequency: "Weekly",
			dailyrespitefee: 0
		}
		// roomoptions: {
		// 	occupancies: ["Single", "Companion", "Shared"],
		// 	ensuites: ["Private ensuite", "Shared ensuite", "No ensuite"],
		// 	srsFeeFrequencies: ["Weekly", "Monthly"],
		// 	roomsize: [{
		// 			type: "Size-is-static",
		// 			label: "Size is always the same for this room type",
		// 		},
		// 		{
		// 			type: "Size-varies-no-minimum",
		// 			label: "Size varies for this room type between a min and max",
		// 		},
		// 		{
		// 			type: "Size-varies-has-minimum",
		// 			label: "Size varies but this room type has a minimum size",
		// 		},
		// 	],
		// },
	},
	mutations: {},
	getters: {
		room: (state) => state.room
	},
	actions: {}
};
